import { LegacyCRMIframeID, ReactToLegacyCrmPostMessageAction } from './Constants'

interface LegacyCRMIframeTriggerClickEventProps {
  action: string
  iframeLoaded: boolean
  idSelector: string
  legacyCRMUrl: string // Pass the URL as a parameter instead of using a hook
}

/**
 * -----------------------------------------------------------------------------------
 * To do: This is a standard postMessage call to trigger click event in CRM Iframe
 * -----------------------------------------------------------------------------------
 *
 * Sends a postMessage to the legacy CRM iframe once it has loaded.
 *
 * Props:
 * @param action (string): Determines the PostMessage action to differentiate event types
 * @param iframeLoaded (boolean): Determines whether the iframe is ready to receive messages.
 * @param idSelector (string): Id selector to trigger which element to trigger click event on.
 * @param legacyCRMUrl (string): URL of the legacy CRM iframe.
 *
 * This function:
 * 1. Checks if the iframe has loaded.
 * 2. Constructs a message payload with the given options.
 * 3. Locates the iframe by ID (`LegacyCRMIframeID`).
 * 4. Sends the message using `postMessage` to the iframe's content window.
 *
 * Note: This function is side-effect only and does not return anything.
 */
export const LegacyCRMIframeTriggerClickEvent = ({
  action = ReactToLegacyCrmPostMessageAction.ReactToIframeMessageTriggerClickEvent,
  iframeLoaded,
  idSelector,
  legacyCRMUrl,
}: LegacyCRMIframeTriggerClickEventProps): void => {
  if (!iframeLoaded) return

  const message = {
    action,
    data: {
      idSelector,
    },
  }

  const iframe = document.getElementById(LegacyCRMIframeID) as HTMLIFrameElement | null
  if (iframe && iframe.contentWindow) {
    iframe.contentWindow.postMessage(message, legacyCRMUrl)
  }
}
